import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/templates/new')({
  component: () => <></>,
  meta: () => [{ title: 'New Template' }],
})
